import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { Modal, Button as BButton, Spinner } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
    faUserPlus, 
    faDownload,
    faUsers,
    faUserShield,
    faBuilding,
    faUserTie
} from '@fortawesome/free-solid-svg-icons';
import swal from 'sweetalert';
import { createUserAction, updateUserAction, deleteParamAction, getUsersAction, 
resetSaveDoneAction, resetUserPasswordActionsAction, resendUserParamsActionsAction, startLoader } from '../../../store/actions/UserAction';
import { listProvidersAction } from '../../../store/actions/ProviderActions';
import { getSouscripteursAction, getContractPerClientAction } from '../../../store/actions/ContratActions';
import Select from 'react-select';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import './User.css';
import { FilterMatchMode, FilterOperator } from 'primereact/api';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { Tag } from 'primereact/tag';
import { Calendar } from 'primereact/calendar';
import { DataTableBase } from '../DataTables/DataTableBase';
import { TabView, TabPanel } from 'primereact/tabview';
import { Tooltip } from 'primereact/tooltip';
import { currentUser } from "../../../store/selectors/CurrentUserSelector";
import { useTranslation } from "react-i18next";

const User = (props) => {
    const { t } = useTranslation();
    let errorsObj = { name: '', username: '', email: '', password: '', confirmPassword: '', userType: '', firstName: '', lastName: '', fullName: '' };
    
    // Form states
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [username, setUsername] = useState('');
    const [phonenumber, setPhonenumber] = useState('');
    const [userType, setUserType] = useState('');
    const [providerId, setProviderId] = useState('');
    const [profils, setProfils] = useState([]);
    const [client, setClient] = useState('');
    const [clientName, setClientName] = useState('')
    const [policies, setPolicies] = useState([]);
    const [errors, setErrors] = useState(errorsObj);
    const [id, setId] = useState('');
    const [updateMode, setUpdateMode] = useState(false);
    const [firstName, setFirstName] = useState('');
    const [lastName, setLastName] = useState('');
    const [fullName, setFullName] = useState('');
    
    // Modal states
    const [addCard, setAddCard] = useState(false);
    
    // Filter states
    const [adminFilters, setAdminFilters] = useState(null);
    const [globalAdminFilterValue, setGlobalAdminFilterValue] = useState('');
    const [providerFilters, setProviderFilters] = useState(null);
    const [globalProviderFilterValue, setGlobalProviderFilterValue] = useState('');
    const [rhFilters, setRhFilters] = useState(null);
    const [globalRhFilterValue, setGlobalRhFilterValue] = useState('');
    const [clientFilters, setClientFilters] = useState(null);
    const [globalClientFilterValue, setGlobalClientFilterValue] = useState('');

    // Auto-génération du fullName quand firstName ou lastName change
    useEffect(() => {
        if (userType === 'provider' && (firstName || lastName)) {
            setFullName(`Dr. ${firstName} ${lastName}`.trim());
        }
    }, [firstName, lastName, userType]);

    const initFilters = () => {
        setAdminFilters({
            global: { value: null, matchMode: FilterMatchMode.CONTAINS },
            username: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
            email: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
            phone: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
            'userProfil.profil.nameFr': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
            createdAt: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.DATE_IS }] },
        });
        setGlobalAdminFilterValue("");

        setProviderFilters({
            global: { value: null, matchMode: FilterMatchMode.CONTAINS },
            username: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
            email: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
            phone: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
            'userProfil.profil.nameFr': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
            'provider.providerName': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
            fullName: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
            createdAt: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.DATE_IS }] },
        });
        setGlobalProviderFilterValue("");

        setRhFilters({
            global: { value: null, matchMode: FilterMatchMode.CONTAINS },
            username: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
            email: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
            phone: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
            'userProfil.profil.nameFr': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
            'rh.clientName': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
            'rh.policies': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
            createdAt: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.DATE_IS }] },
        });
        setGlobalRhFilterValue("");

        setClientFilters({
            global: { value: null, matchMode: FilterMatchMode.CONTAINS },
            username: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
            email: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
            phone: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
            createdAt: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.DATE_IS }] },
        });
        setGlobalClientFilterValue("");
    };

    const renderHeader = (type) => {
        const getFilterValue = () => {
            switch(type) {
                case 'admin': return globalAdminFilterValue;
                case 'provider': return globalProviderFilterValue;
                case 'rh': return globalRhFilterValue;
                default: return globalClientFilterValue;
            }
        };

        return (
            <div className="d-flex justify-content-between align-items-center">
                <Button 
                    type="button" 
                    icon="pi pi-filter-slash"  
                    label={t('common.reinit')} 
                    outlined 
                    onClick={clearFilter}
                    className="me-2"
                    size="small"
                />
                <div className="p-input-icon-left">
                    <i className="pi pi-search" />
                    <InputText 
                        value={getFilterValue()} 
                        onChange={(e) => onGlobalFilterChange(e, type)} 
                        placeholder={t('common.search')}
                        size="small"
                    />
                </div>
            </div>
        );
    };

    const clearFilter = () => {
        initFilters();
    };

    const onGlobalFilterChange = (e, type) => {
        const value = e.target.value;
        if(type === 'admin') {
            let _filters = { ...adminFilters };
            _filters['global'].value = value;
            setAdminFilters(_filters);
            setGlobalAdminFilterValue(value);
        }else if(type === 'provider') {
            let _filters = { ...providerFilters };
            _filters['global'].value = value;
            setProviderFilters(_filters);
            setGlobalProviderFilterValue(value);
        }else if(type === 'rh') {
            let _filters = { ...rhFilters };
            _filters['global'].value = value;
            setRhFilters(_filters);
            setGlobalRhFilterValue(value);
        }else{
            let _filters = { ...clientFilters };
            _filters['global'].value = value;
            setClientFilters(_filters);
            setGlobalClientFilterValue(value);
        }
    };

    const setColumns = (type) => {
        let arr = null;
        if(type === 'admin') {
            arr = [
                {name: 'username', headerName: t('common.name'), filterPlaceholder: t('common.filter-name'), style: { minWidth: '12rem' }, filter: true, bodyTemplate: null},
                {name: 'email', headerName: t('client.email'), filterPlaceholder: t('common.email-filter'), style: { minWidth: '12rem' }, filter: true, bodyTemplate: null},
                {name: 'phone', headerName: t('common.phone'), filterPlaceholder: t('common.phone-filter'), style: { minWidth: '12rem' }, filter: true, bodyTemplate: null},
                {name: 'userProfil.profil.nameFr', headerName: "Profils", filterPlaceholder: 'Filtrer par profils', style: { minWidth: '12rem' }, filter: true, bodyTemplate: profilsBodyTemplate},
                {name: 'createdAt', filterField: 'createdAt', dataType: 'date', headerName: 'Créé le', filterPlaceholder: t('facturation.create-date-filter'), style: { minWidth: '6rem' }, filter: true, bodyTemplate: datePaiementBodyTemplate, filterElement: dateFilterTemplate},
                {name: 'actions', headerName: 'Actions', filterPlaceholder: '', style: { minWidth: '6rem'}, filter: false, bodyTemplate: getActionsTemplate},
            ]
        }else if(type === 'provider') {
            arr = [
                {name: 'username', headerName: t('common.name'), filterPlaceholder: t('common.filter-name'), style: { minWidth: '12rem' }, filter: true, bodyTemplate: null},
                {name: 'fullName', headerName: 'Nom complet', filterPlaceholder: 'Filtrer par nom complet', style: { minWidth: '12rem' }, filter: true, bodyTemplate: null},
                {name: 'email', headerName: t('client.email'), filterPlaceholder: t('common.email-filter'), style: { minWidth: '12rem' }, filter: true, bodyTemplate: null},
                {name: 'phone', headerName: t('common.phone'), filterPlaceholder: t('common.phone-filter'), style: { minWidth: '12rem' }, filter: true, bodyTemplate: null},
                {name: 'userProfil.profil.nameFr', headerName: "Profils", filterPlaceholder: 'Filtrer par profils', style: { minWidth: '12rem' }, filter: true, bodyTemplate: profilsBodyTemplate},
                {name: 'provider.providerName', headerName: t('dashboard.provider'), filterPlaceholder: t('facturation.provider-filter'), style: { minWidth: '12rem' }, filter: true, bodyTemplate: null},
                {name: 'createdAt', filterField: 'createdAt', dataType: 'date', headerName: 'Créé le', filterPlaceholder: t('facturation.create-date-filter'), style: { minWidth: '6rem' }, filter: true, bodyTemplate: datePaiementBodyTemplate, filterElement: dateFilterTemplate},
                {name: 'actions', headerName: 'Actions', filterPlaceholder: '', style: { minWidth: '6rem'}, filter: false, bodyTemplate: getActionsTemplate},
            ]
        }else if(type === 'rh') {
            arr = [
                {name: 'username', headerName: t('common.name'), filterPlaceholder: t('common.filter-name'), style: { minWidth: '12rem' }, filter: true, bodyTemplate: null},
                {name: 'email', headerName: t('client.email'), filterPlaceholder: t('common.email-filter'), style: { minWidth: '12rem' }, filter: true, bodyTemplate: null},
                {name: 'phone', headerName: t('common.phone'), filterPlaceholder: t('common.phone-filter'), style: { minWidth: '12rem' }, filter: true, bodyTemplate: null},
                {name: 'userProfil.profil.nameFr', headerName: "Profils", filterPlaceholder: 'Filtrer par profils', style: { minWidth: '12rem' }, filter: true, bodyTemplate: profilsBodyTemplate},
                {name: 'rh.clientName', headerName: "Client", filterPlaceholder: 'Filtrer par client', style: { minWidth: '12rem' }, filter: true, bodyTemplate: null},
                {name: 'rh.polices', headerName: "Polices", filterPlaceholder: 'Filtrer par polices', style: { minWidth: '12rem' }, filter: true, bodyTemplate: policesBodyTemplate},
                {name: 'createdAt', filterField: 'createdAt', dataType: 'date', headerName: 'Créé le', filterPlaceholder: t('facturation.create-date-filter'), style: { minWidth: '6rem' }, filter: true, bodyTemplate: datePaiementBodyTemplate, filterElement: dateFilterTemplate},
                {name: 'actions', headerName: 'Actions', filterPlaceholder: '', style: { minWidth: '6rem'}, filter: false, bodyTemplate: getActionsTemplate},
            ]
        }else{
            arr = [
                {name: 'username', headerName: t('common.name'), filterPlaceholder: t('common.filter-name'), style: { minWidth: '12rem' }, filter: true, bodyTemplate: null},
                {name: 'email', headerName: t('client.email'), filterPlaceholder: t('common.email-filter'), style: { minWidth: '12rem' }, filter: true, bodyTemplate: null},
                {name: 'phone', headerName: t('common.phone'), filterPlaceholder: t('common.phone-filter'), style: { minWidth: '12rem' }, filter: true, bodyTemplate: null},
                {name: 'createdAt', filterField: 'createdAt', dataType: 'date', headerName: 'Créé le', filterPlaceholder: t('facturation.create-date-filter'), style: { minWidth: '6rem' }, filter: true, bodyTemplate: datePaiementBodyTemplate, filterElement: dateFilterTemplate},
                {name: 'actions', headerName: 'Actions', filterPlaceholder: '', style: { minWidth: '6rem'}, filter: false, bodyTemplate: getActionsTemplate},
            ]
        }
        return arr;
    };

    const getActionsTemplate = (rowData) => {
        return (
            <div className="d-flex justify-content-center gap-1">
                {hasMenu('MENPARAMUSER') && canDo('MENPARAMUSER', 'UPDATEUSER') && (
                    <button 
                        className="btn btn-sm btn-outline-primary"
                        data-pr-tooltip="Modifier"
                        data-pr-position="bottom"
                        onClick={e => updateAction(rowData)}
                        title={t('common.edit')}
                    >
                        <i className="fa fa-pencil"></i>
                    </button>
                )}
                {hasMenu('MENPARAMUSER') && canDo('MENPARAMUSER', 'DELETEUSER') && (
                    <button 
                        className="btn btn-sm btn-outline-danger"
                        data-pr-tooltip="Désactiver"
                        data-pr-position="bottom"
                        onClick={() => handleDelete(rowData)}
                        title={t('common.delete')}
                    >
                        <i className="la la-ban"></i>
                    </button>
                )}
                {hasMenu('MENPARAMUSER') && canDo('MENPARAMUSER', 'RESETUSERPASSWORD') && (
                    <button 
                        className="btn btn-sm btn-outline-warning"
                        data-pr-tooltip="Réinitialiser le mot de passe"
                        data-pr-position="bottom"
                        onClick={() => handleResetPassword(rowData)}
                        title="Réinitialiser"
                    >
                        <i className="fa fa-key"></i>
                    </button>
                )}
                {hasMenu('MENPARAMUSER') && canDo('MENPARAMUSER', 'RESENDUSERPARAMS') && rowData.type === 'Patient' && (
                    <button 
                        className="btn btn-sm btn-outline-info"
                        data-pr-tooltip="Renvoyer les paramètres"
                        data-pr-position="bottom"
                        onClick={() => handleResendParams(rowData)}
                        title="Renvoyer paramètres"
                    >
                        <i className="fa fa-lock"></i>
                    </button>
                )}
                <Tooltip target=".btn" />
            </div>
        );
    };

    const handleDelete = (rowData) => {
        swal({
            title: "Supprimer l'utilisateur " + rowData.username + " ?",
            text: "Une fois l'utilisateur supprimé, il ne pourra plus être accessible",
            icon: "warning",
            buttons: true,
            dangerMode: true,
        }).then((willDelete) => {
            if (willDelete) {
                let data = { id: rowData.id };
                props.dispatch(startLoader());
                props.dispatch(deleteParamAction('user', data));
            }
        });
    };

    const handleResetPassword = (rowData) => {
        swal({
            title: "Réinitialisation de mot passe",
            text: "Vous êtes sur le point de réinitialiser le mot de passe pour l'utilisateur " +
                rowData.username + ". Cette génèrera un mot de passe aléatoire qu'il recevra par email et sms. Voulez-vous poursuivre?",
            icon: "warning",
            buttons: true,
            dangerMode: true,
        }).then((willDelete) => {
            if (willDelete) {
                props.dispatch(startLoader());
                props.dispatch(resetUserPasswordActionsAction(rowData.id));
            }
        });
    };

    const handleResendParams = (rowData) => {
        swal({
            title: "Renvoie des paramètres de connexion",
            text: "Vous êtes sur le point de renvoyer les paramètres de l'utilisateur " +
                rowData.username + ". Cette génèrera un mot de passe aléatoire qu'il recevra par email et sms, ainsi qu'une adresse de connexion. Voulez-vous poursuivre?",
            icon: "warning",
            buttons: true,
            dangerMode: true,
        }).then((willDelete) => {
            if (willDelete) {
                props.dispatch(startLoader());
                props.dispatch(resendUserParamsActionsAction(rowData.id));
            }
        });
    };

    const dateFilterTemplate = (options) => {
        return <Calendar value={options.value} onChange={(e) => options.filterCallback(e.value, options.index)} dateFormat="dd/mm/yy" placeholder="dd/mm/yyyy" mask="99/99/9999" />;
    };

    const datePaiementBodyTemplate = (rowData) => {
        return formatDate(rowData.createdAt);
    };

    const profilsBodyTemplate = (rowData) => {
        return rowData.userProfil.map((profil, index) => {
            return <Tag key={index} value={profil.profil?.nameFr} severity={'secondary'} className="me-1" />;
        });
    };

    const policesBodyTemplate = (rowData) => {
        return rowData.rh?.polices?.map((police, index) => {
            return <Tag key={index} value={police} severity={'info'} className="me-1" />;
        });
    };

    const formatDate = (value) => {
        return value.toLocaleDateString('fr-FR', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric'
        });
    };

    const canDo = (menuCode, actionCode) => {
        let theMenu = props.currentUser.menus?.find(menu => menu.code === menuCode);
        if(!theMenu){
            return false;
        }else{
            return theMenu.actionMenus?.filter(action => action.code === actionCode).length > 0;
        }
    }
    
    const hasMenu = (menuCode) => {
        return props.currentUser.menus?.filter(menu => menu.code === menuCode).length > 0;
    }
    
    useEffect(() => {
        props.dispatch(listProvidersAction());
        props.dispatch(getSouscripteursAction());
        initFilters();
    }, []);

    const resetForm = () => {
        setId("");
        setEmail("");
        setUsername("");
        setPhonenumber("");
        setProviderId("");
        setUserType("");
        setProfils([]);
        setClient("");
        setClientName("");
        setPolicies([]);
        setPassword("");
        setConfirmPassword("");
        setFirstName("");
        setLastName("");
        setFullName("");
        setErrors(errorsObj);
        setUpdateMode(false);
    };

    function onUserSave(e) {
        e.preventDefault();
        let error = false;
        const errorObj = { ...errorsObj };
        if (username === '') {
            errorObj.username = 'le champ username est obligatoire';
            error = true;
        }
        if (email === '') {
            errorObj.email = 'le champ email est obligatoire';
            error = true;
        }
        
        // Validation spécifique pour les prestataires
        if (userType === 'provider') {
            if (firstName === '') {
                errorObj.firstName = 'le prénom est obligatoire pour un prestataire';
                error = true;
            }
            if (lastName === '') {
                errorObj.lastName = 'le nom de famille est obligatoire pour un prestataire';
                error = true;
            }
        }
        if(!updateMode){
            if (password === '') {
                errorObj.password = 'le mot de passe est obligatoire';
                error = true;
            }
            if (confirmPassword === '' || confirmPassword !== password ) {
                errorObj.confirmPassword = 'les mots de passe ne correspondent pas';
                error = true;
            }
        }
        setErrors(errorObj);
        if (error) {
            swal('Oops', t('common.check-form-fields'), "error");
            return;
        }
        props.dispatch(startLoader());
        
        let obj = { 
            email, 
            password, 
            username, 
            confirmPassword, 
            phone: phonenumber, 
            profils, 
            providerId, 
            type: userType,
            clientId: client,
            clientName,
            polices: policies 
        };
        if (userType === 'provider') {
            obj.firstName = firstName;
            obj.lastName = lastName;
            obj.fullName = fullName;
        }

        if(updateMode) {
            props.dispatch(updateUserAction(id, obj));
        }else{
            props.dispatch(createUserAction(obj));
        }
        
        setAddCard(false);
        resetForm();
    }

    const updateAction = (data) => {
        setId(data.id);
        setEmail(data.email);
        setUsername(data.username);
        setPhonenumber(data.phone);
        setProviderId(data.provider?.id);
        setUserType(data.type);
        setProfils(data.userProfil ? data.userProfil.map(res => {return res.profil?.id}) : []);
        setClient(data.clientId);
        setClientName(data.clientName);
        setPolicies(data.polices || []);
        
        // Champs spécifiques aux prestataires
        if (data.type === 'provider') {
            setFirstName(data.firstName || '');
            setLastName(data.lastName || '');
            setFullName(data.fullName || '');
        }
        
        setUpdateMode(true);
        setAddCard(true);
    }

    useEffect(() => {
        resetForm();
        setAddCard(false);
    }, [props.users]);

    const newUserCreate = () => {
        resetForm();
        setAddCard(true);
    }

    const handleDownloadTemplate = () => {
        console.log('Download user template');
    };

    return (
        <>
            {/* Header */}
            <div className="provider-type-header mb-0 form-head bg-white p-3 bt-5 border-top-solid">
                <div>
                    <h4 className="mb-1">{t('user.users')}</h4>
                    <p className="text-muted mb-0 small">{t('common.manage-system-users')}</p>
                </div>
                <div className="d-flex gap-2">
                    {/* <button
                        type="button"
                        className="btn btn-outline-primary btn-sm"
                        onClick={handleDownloadTemplate}
                    >
                        <FontAwesomeIcon icon={faDownload} className="me-1" />
                        {t("common.download-template")}
                    </button> */}
                    
                    {hasMenu('MENPARAMUSER') && canDo('MENPARAMUSER', 'CREATEUSER') && (
                        <button
                            type="button"
                            className="btn btn-primary btn-sm"
                            onClick={newUserCreate}
                        >
                            <FontAwesomeIcon icon={faUserPlus} className="me-1" />
                            Nouvel utilisateur
                        </button>
                    )}
                </div>
            </div>

            {/* Modal for creating/editing user */}
            <Modal 
                show={addCard} 
                onHide={() => setAddCard(false)}
                centered
                backdrop="static"
                size="lg"
            >
                <Modal.Header closeButton className="border-bottom">
                    <Modal.Title className="h5">
                        {!updateMode ? "Créer un nouvel utilisateur" : `Modifier l'utilisateur ${username}`}
                    </Modal.Title>
                </Modal.Header>
                
                <Modal.Body className="p-4">
                    <form onSubmit={onUserSave}>
                        <div className="row">
                            <div className="col-md-6 mb-3">
                                <label className="form-label">{t('client.type')}</label>
                                <select
                                    value={userType}
                                    className={`form-control ${errors.userType ? 'is-invalid' : ''}`}
                                    onChange={(e) => setUserType(e.target.value)}
                                >
                                    <option value=''>Choisir...</option>
                                    {hasMenu('MENPARAMUSER') && canDo('MENPARAMUSER', 'CREATEADMINUSER') && 
                                        <option value='admin'>Administrateur</option>
                                    }
                                    <option value='provider'>{t('dashboard.provider')}</option>
                                    <option value='rh'>{t('dashboard.rh')}</option>
                                </select>
                                {errors.userType && <div className="invalid-feedback">{errors.userType}</div>}
                            </div>

                            {userType === 'provider' && (
                                <div className="col-md-6 mb-3">
                                    <label className="form-label">{t('dashboard.provider')}</label>
                                    <Select
                                        className="select-search"
                                        value={props.providers.filter(elt => parseInt(elt.id) === parseInt(providerId)).map(res => ({label: res.providerName, value: res.id}))}
                                        placeholder="Choisir le prestataire"
                                        onChange={(val) => setProviderId(val?.value || '')}
                                        options={props.providers?.map((opt) => ({label: opt.providerName, value: opt.id}))}
                                        isClearable
                                    />
                                </div>
                            )}

                            {/* Champs spécifiques aux prestataires/médecins */}
                            {userType === 'provider' && (
                                <>
                                    <div className="col-md-6 mb-3">
                                        <label className="form-label">Prénom </label>
                                        <input
                                            type='text'
                                            className={`form-control ${errors.firstName ? 'is-invalid' : ''}`}
                                            placeholder='Alex'
                                            value={firstName}
                                            onChange={(e) => setFirstName(e.target.value)}
                                        />
                                        {errors.firstName && <div className="invalid-feedback">{errors.firstName}</div>}
                                    </div>

                                    <div className="col-md-6 mb-3">
                                        <label className="form-label">Nom de famille </label>
                                        <input
                                            type='text'
                                            className={`form-control ${errors.lastName ? 'is-invalid' : ''}`}
                                            placeholder='Kwame'
                                            value={lastName}
                                            onChange={(e) => setLastName(e.target.value)}
                                        />
                                        {errors.lastName && <div className="invalid-feedback">{errors.lastName}</div>}
                                    </div>

                                    <div className="col-md-6 mb-3">
                                        <label className="form-label">Nom complet</label>
                                        <input
                                            type='text'
                                            className="form-control"
                                            value={fullName}
                                            onChange={(e) => setFullName(e.target.value)}
                                            placeholder="Généré automatiquement"
                                        />
                                        <small className="text-muted">Ce champ est généré automatiquement à partir du prénom et nom</small>
                                    </div>
                                </>
                            )}

                            {userType === 'rh' && (
                                <>
                                    <div className="col-md-6 mb-3">
                                        <label className="form-label">{t('patient.suscriber')}</label>
                                        <Select
                                            className="select-search"
                                            value={props.souscripteurs?.filter(elt => client === elt.codeAssu).map((opt) => ({label: opt.nom_Assu, value: opt.codeAssu}))}
                                            placeholder="Choisir le souscripteur"
                                            onChange={(val) => {
                                                setClient(val?.value || '');
                                                setClientName(val?.label || '');
                                                if (val?.value) {
                                                    props.dispatch(getContractPerClientAction(val.value));
                                                }
                                            }}
                                            options={props.souscripteurs?.map((opt) => ({label: opt.nom_Assu, value: opt.codeAssu}))}
                                            isClearable
                                        />
                                    </div>
                                    <div className="col-md-12 mb-3">
                                        <label className="form-label">{t('common.policies')}</label>
                                        <Select
                                            className="select-search"
                                            value={props.contratPerClient?.filter(elt => policies.includes(elt.numeroPolice)).map((opt) => ({label: opt.numeroPolice, value: opt.numeroPolice}))}
                                            placeholder="Choisir les polices"
                                            isMulti
                                            onChange={(vals) => setPolicies(vals ? vals.map(val => val.value) : [])}
                                            options={props.contratPerClient?.map((opt) => ({label: opt.numeroPolice, value: opt.numeroPolice}))}
                                        />
                                    </div>
                                </>
                            )}

                            <div className="col-md-6 mb-3">
                                <label className="form-label">Username</label>
                                <input
                                    type='text'
                                    className={`form-control ${errors.username ? 'is-invalid' : ''}`}
                                    placeholder='MD'
                                    value={username}
                                    onChange={(e) => setUsername(e.target.value)}
                                />
                                {errors.username && <div className="invalid-feedback">{errors.username}</div>}
                            </div>

                            <div className="col-md-6 mb-3">
                                <label className="form-label">{t('common.email')}</label>
                                <input
                                    type='email'
                                    className={`form-control ${errors.email ? 'is-invalid' : ''}`}
                                    placeholder='user@example.com'
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                />
                                {errors.email && <div className="invalid-feedback">{errors.email}</div>}
                            </div>

                            <div className="col-md-6 mb-3">
                                <label className="form-label">Téléphone</label>
                                <PhoneInput
                                    country={'ci'}
                                    onlyCountries={['cm','ci','cd']}
                                    localization={'fr'}
                                    value={phonenumber}
                                    enableSearch={true}
                                    autoFormat={phonenumber ? !phonenumber.startsWith('225') : true}
                                    onChange={phone => setPhonenumber(phone)}
                                    containerClass="w-100"
                                    inputClass="form-control"
                                />
                            </div>

                            <div className="col-md-12 mb-3">
                                <label className="form-label">Profils</label>
                                <Select
                                    className="select-search"
                                    value={props.profilsData?.filter(elt => profils.includes(elt.id)).map(res => ({label: res.nameFr, value: res.id}))}
                                    disabled={props.showLoading}
                                    placeholder="Choisir les profils"
                                    isMulti
                                    onChange={(vals) => setProfils(vals ? vals.map(val => val.value) : [])}
                                    options={props.profilsData?.map((opt) => ({label: opt.nameFr, value: opt.id}))}
                                />
                            </div>

                            {!updateMode && (
                                <>
                                    <div className="col-md-6 mb-3">
                                        <label className="form-label">Mot de passe</label>
                                        <input
                                            type='password'
                                            className={`form-control ${errors.password ? 'is-invalid' : ''}`}
                                            placeholder='••••••••'
                                            value={password}
                                            onChange={(e) => setPassword(e.target.value)}
                                        />
                                        {errors.password && <div className="invalid-feedback">{errors.password}</div>}
                                    </div>
                                    <div className="col-md-6 mb-3">
                                        <label className="form-label">Confirmer le mot de passe</label>
                                        <input
                                            type='password'
                                            className={`form-control ${errors.confirmPassword ? 'is-invalid' : ''}`}
                                            placeholder='••••••••'
                                            value={confirmPassword}
                                            onChange={(e) => setConfirmPassword(e.target.value)}
                                        />
                                        {errors.confirmPassword && <div className="invalid-feedback">{errors.confirmPassword}</div>}
                                    </div>
                                </>
                            )}
                        </div>
                    </form>
                </Modal.Body>
                
                <Modal.Footer className="border-top">
                    <button 
                        type="button" 
                        className="btn btn-outline-secondary"
                        onClick={() => setAddCard(false)}
                        disabled={props.showLoading}
                    >
                        {t('common.cancel')}
                    </button>
                    
                    {props.showLoading ? (
                        <BButton variant="primary" disabled>
                            <Spinner
                                as="span"
                                animation="border"
                                size="sm"
                                role="status"
                                aria-hidden="true"
                            />
                            <span className="ms-2">{t('common.saving')}</span>
                        </BButton>
                    ) : (
                        <button 
                            type="submit" 
                            className="btn btn-primary"
                            onClick={onUserSave}
                        >
                            {t('common.save')}
                        </button>
                    )}
                </Modal.Footer>
            </Modal>

            {/* TabView with modern styling */}
            <div className="card border-0 shadow-sm bg-white">
                <div className="card-body p-0">
                    <TabView className="custom-tabview">
                        <TabPanel 
                            header={
                                <div className="d-flex align-items-center">
                                    <FontAwesomeIcon icon={faUserShield} className="me-2" />
                                    Administrateurs
                                </div>
                            }
                        >
                            <DataTableBase 
                                data={props.users.filter(user => user.type === 'admin').map(user => {
                                    user.createdAt = new Date(user.createdAt);
                                    user.profils = user.userProfil.map(prof => prof.profil?.nameFr).toString();
                                    return user;
                                })}
                                emptyMessage="Aucun administrateur trouvé" 
                                filters={adminFilters}
                                globalFiltersFields={['username', 'email', 'phone', 'userProfil.profil.nameFr', 'createdAt']}
                                header={renderHeader('admin')}
                                columns={setColumns('admin')}
                                exportColumns={[
                                    { title: t('common.name'), dataKey: 'username' },
                                    { title: 'Email', dataKey: 'email' },
                                    { title: t('common.phone'), dataKey: 'phone' },
                                    { title: 'Profils', dataKey: 'profils' },
                                    { title: t('common.create-date'), dataKey: 'createdAt' },
                                ]}
                                rows={10} 
                                showExport={true}
                                exportFilename={"administrateurs"}
                                loading={props.showLoading}
                            />
                        </TabPanel>
                        
                        <TabPanel 
                            header={
                                <div className="d-flex align-items-center">
                                    <FontAwesomeIcon icon={faBuilding} className="me-2" />
                                    Prestataires
                                </div>
                            }
                        >
                            <DataTableBase 
                                data={props.users.filter(user => user.type === 'provider').map(user => {
                                    user.createdAt = new Date(user.createdAt);
                                    user.profils = user.userProfil.map(prof => prof.profil?.nameFr).toString();
                                    return user;
                                })}
                                emptyMessage="Aucun utilisateur prestataire trouvé" 
                                filters={providerFilters}
                                globalFiltersFields={['username', 'email', 'phone', 'userProfil.profil.nameFr', 'provider.providerName', 'fullName', 'createdAt']}
                                header={renderHeader('provider')}
                                columns={setColumns('provider')}
                                exportColumns={[
                                    { title: t('common.name'), dataKey: 'username' },
                                    { title: 'FullName', dataKey: 'fullName' },
                                    { title: 'Email', dataKey: 'email' },
                                    { title: t('common.phone'), dataKey: 'phone' },
                                    { title: 'Profils', dataKey: 'profils' },
                                    { title: t('common.create-date'), dataKey: 'createdAt' },
                                ]}
                                rows={10} 
                                showExport={true}
                                exportFilename={"utilisateurs_prestataire"}
                                loading={props.showLoading}
                            />
                        </TabPanel>
                        
                        <TabPanel 
                            header={
                                <div className="d-flex align-items-center">
                                    <FontAwesomeIcon icon={faUserTie} className="me-2" />
                                    Ressources Humaines
                                </div>
                            }
                        >
                            <DataTableBase 
                                data={props.users.filter(user => user.type === 'rh').map(user => {
                                    user.createdAt = new Date(user.createdAt);
                                    user.policesString = user.rh?.polices?.join(', ') || '';
                                    user.client = user.rh?.clientName || '';
                                    return user;
                                })}
                                emptyMessage="Aucun utilisateur RH trouvé" 
                                filters={rhFilters}
                                globalFiltersFields={['username', 'email', 'phone', 'rh.clientName', 'rh.polices', 'userProfil.profil.nameFr', 'createdAt']}
                                header={renderHeader('rh')}
                                columns={setColumns('rh')}
                                exportColumns={[
                                    { title: t('common.name'), dataKey: 'username' },
                                    { title: 'Email', dataKey: 'email' },
                                    { title: t('common.phone'), dataKey: 'phone' },
                                    { title: 'Client', dataKey: 'client' },
                                    { title: 'Polices', dataKey: 'policesString' },
                                    { title: t('common.create-date'), dataKey: 'createdAt' },
                                ]}
                                rows={10} 
                                showExport={true}
                                exportFilename={"utilisateurs_rh"}
                                loading={props.showLoading}
                            />
                        </TabPanel>
                        
                        <TabPanel 
                            header={
                                <div className="d-flex align-items-center">
                                    <FontAwesomeIcon icon={faUsers} className="me-2" />
                                    Assurés
                                </div>
                            }
                        >
                            <DataTableBase 
                                data={props.users.filter(user => user.type === 'Patient').map(user => {
                                    user.createdAt = new Date(user.createdAt);
                                    return user;
                                })}
                                emptyMessage="Aucun assuré trouvé" 
                                filters={clientFilters}
                                globalFiltersFields={['username', 'email', 'phone', 'createdAt']}
                                header={renderHeader('client')}
                                columns={setColumns('client')}
                                exportColumns={[
                                    { title: t('common.name'), dataKey: 'username' },
                                    { title: 'Email', dataKey: 'email' },
                                    { title: t('common.phone'), dataKey: 'phone' },
                                    { title: t('common.create-date'), dataKey: 'createdAt' },
                                ]}
                                rows={10} 
                                showExport={true}
                                exportFilename={"assures"}
                                loading={props.showLoading}
                            />
                        </TabPanel>
                    </TabView>
                </div>
            </div>

            {/* Custom CSS for TabView and overall styling */}
            <style jsx>{`
                .custom-tabview .p-tabview-nav {
                    background: white;
                    border: none;
                    border-bottom: 1px solid #dee2e6;
                }
                
                .custom-tabview .p-tabview-nav li .p-tabview-nav-link {
                    background: transparent;
                    border: none;
                    color: #6c757d;
                    padding: 1rem 1.5rem;
                    font-weight: 500;
                    transition: all 0.2s ease;
                }
                
                .custom-tabview .p-tabview-nav li .p-tabview-nav-link:hover {
                    background: rgba(0,123,255,0.05);
                    color: #007bff;
                    transform: translateY(-2px);
                }
                
                .custom-tabview .p-tabview-nav li.p-highlight .p-tabview-nav-link {
                    background: white;
                    color: #007bff;
                    border-bottom: 3px solid #007bff;
                    font-weight: 600;
                }
                
                .custom-tabview .p-tabview-panels {
                    background: white;
                    border: none;
                    padding: 1.5rem;
                }
                
                .provider-type-header {
                    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
                    color: white;
                    border-radius: 8px 8px 0 0;
                }
                
                .provider-type-header h4 {
                    color: white;
                    font-weight: 600;
                }
                
                .provider-type-header p {
                    color: rgba(255, 255, 255, 0.8);
                }
                
                .provider-type-header .btn-outline-primary {
                    border-color: rgba(255, 255, 255, 0.5);
                    color: white;
                }
                
                .provider-type-header .btn-outline-primary:hover {
                    background-color: rgba(255, 255, 255, 0.1);
                    border-color: white;
                }
                
                .provider-type-header .btn-primary {
                    background-color: rgba(255, 255, 255, 0.2);
                    border-color: rgba(255, 255, 255, 0.3);
                    color: white;
                }
                
                .provider-type-header .btn-primary:hover {
                    background-color: rgba(255, 255, 255, 0.3);
                    border-color: rgba(255, 255, 255, 0.5);
                }
                
                /* Phone input styling */
                .react-tel-input .form-control {
                    width: 100%;
                    height: auto;
                    border-radius: 0.375rem;
                }
                
                /* Modal improvements */
                .modal-lg {
                    max-width: 800px;
                }
                
                /* Form validation styling */
                .is-invalid {
                    border-color: #dc3545;
                }
                
                .invalid-feedback {
                    display: block;
                    width: 100%;
                    margin-top: 0.25rem;
                    font-size: 0.875em;
                    color: #dc3545;
                }
                
                /* Button improvements */
                .btn-sm {
                    padding: 0.25rem 0.5rem;
                    font-size: 0.875rem;
                    border-radius: 0.25rem;
                }
                
                .btn-outline-primary:hover {
                    transform: translateY(-1px);
                    box-shadow: 0 2px 4px rgba(0,123,255,0.2);
                }
                
                .btn-outline-danger:hover {
                    transform: translateY(-1px);
                    box-shadow: 0 2px 4px rgba(220,53,69,0.2);
                }
                
                .btn-outline-warning:hover {
                    transform: translateY(-1px);
                    box-shadow: 0 2px 4px rgba(255,193,7,0.2);
                }
                
                .btn-outline-info:hover {
                    transform: translateY(-1px);
                    box-shadow: 0 2px 4px rgba(13,202,240,0.2);
                }
                
                /* Tag improvements */
                .p-tag {
                    border-radius: 12px;
                    font-size: 0.75rem;
                    font-weight: 500;
                }
                
                /* Form check styling */
                .form-check {
                    padding: 0.5rem 1.25rem;
                    background: #f8f9fa;
                    border-radius: 0.375rem;
                    border: 1px solid #dee2e6;
                }
                
                .form-check-input:checked {
                    background-color: #0d6efd;
                    border-color: #0d6efd;
                }
                
                /* DataTable responsiveness */
                @media (max-width: 768px) {
                    .provider-type-header {
                        flex-direction: column;
                        gap: 1rem;
                    }
                    
                    .provider-type-header .d-flex {
                        flex-direction: column;
                        width: 100%;
                    }
                    
                    .modal-lg {
                        max-width: 95%;
                        margin: 1rem auto;
                    }
                }
            `}</style>
        </>
    );
};

const mapStateToProps = (state) => {
    return {
        users: state.user.users,
        profilsData: state.user.profils,
        providers: state.provider.providers,
        errorMessage: state.user.errorMessage,
        successMessage: state.user.successMessage,
        showLoading: state.user.showLoading,
        saveDone: state.user.saveDone,
        deleteDone: state.user.deleteDone,
        contratPerClient: state.contrat.contratPerClient,
        souscripteurs: state.contrat.souscripteurs,
        currentUser: currentUser(state)
    };
};

export default connect(mapStateToProps)(User);